export enum CommunicationsResponseConferenceParticipantUpdateError {
  unableToUpdateParticipant = 'unableToUpdateParticipant',
}
